import { Tag } from "antd";
import TablePage from "../../components/TablePage";
import axiosInstance from "../../common/api";
import { date2locale } from "../../common/common";

const columns = [
  { title: "ID", key: "id", dataIndex: "id", width: 80 },
  {
    title: "Dipendente",
    key: "employee",
    dataIndex: ["employee", "fullName"],
    ellipsis: true,
    width: 250,
  },
  {
    title: "Data assegnazione",
    key: "assignDate",
    dataIndex: "assignDate",
    render: (date) => (date ? date2locale(date) : "-"),
    width: 180,
  },
  {
    title: "Data restituzione",
    key: "returnDate",
    dataIndex: "returnDate",
    render: (date) => (date ? date2locale(date) : "-"),
    width: 180,
  },
  {
    title: "Stato",
    key: "status",
    dataIndex: "returnDate",
    render: (date) => (
      <Tag color={date ? "default" : "blue"}>{date ? "Restituito" : "In assegnazione"}</Tag>
    ),
    width: 180,
  },
];

export default function DpiAssignmentHistory({ id }) {
  return (
    <TablePage
      key={id}
      columns={columns}
      enableSelection={false}
      showAdd={false}
      searchQueryName={null}
      fetchFunction={({ page, pageSize }) =>
        axiosInstance
          .get(`dpiInventoryUnit/${id}/assignments`, { params: { page, pageSize } })
          .then(({ data }) => data)
      }
    />
  );
}
